/** Query keys that usually carry a numeric / R-prefixed decline code */
export const PAYMENT_ERROR_CODE_SEARCH_PARAM_KEYS = [
  'error_code',
  'ErrorCode',
  'errorCode',
  'ReasonCode',
  'reasonCode',
  'code',
  'errors',
] as const;

/** Query keys that usually carry a payer-facing text message */
export const PAYMENT_ERROR_MESSAGE_SEARCH_PARAM_KEYS = [
  'CardHolderMessage',
  'cardHolderMessage',
  'message',
  'Message',
  'error_message',
  'errorMessage',
] as const;

/** Ambiguous keys: may be a code, Reason name, or free-form text */
export const PAYMENT_ERROR_AMBIGUOUS_SEARCH_PARAM_KEYS = ['reason', 'Reason', 'error'] as const;

/** All payment-fail related query keys (for stripping from URL after handling) */
export const PAYMENT_ERROR_SEARCH_PARAM_KEYS = [
  ...PAYMENT_ERROR_CODE_SEARCH_PARAM_KEYS,
  ...PAYMENT_ERROR_MESSAGE_SEARCH_PARAM_KEYS,
  ...PAYMENT_ERROR_AMBIGUOUS_SEARCH_PARAM_KEYS,
] as const;
